import { Injectable, inject } from "@angular/core";
import {AppPermissions} from "@server-models";
import {Store} from "@ngrx/store";
import {SharedPermissionsSelectors} from "@shared/stores/permissions/store/shared-permissions.selector-type";
import {map, skipUntil} from "rxjs/operators";
import {filter, firstValueFrom, Observable} from "rxjs";
import {EBetaFeatures} from "@shared/enums/beta-features.enum";
import {TUserFeatureFlags} from "@shared/stores/permissions/store/shared-permissions.state";

@Injectable({
  providedIn: 'root',
})
export class SharedPermissionsService {
  private _store = inject(Store);


  hasPermissions$(permissions: AppPermissions[]): Observable<boolean> {
    return this._store.select(SharedPermissionsSelectors.selectUserPermissions).pipe(
      skipUntil(this._store.select(SharedPermissionsSelectors.selectLoaded).pipe(filter(Boolean))),
      map(
        (userPermissions) => permissions.map(permission => Boolean(userPermissions.includes(permission))).every(permission => permission)
      )
    );
  }

  hasFeatureAccess$(feature: EBetaFeatures): Observable<boolean> {
    return this._store.select(SharedPermissionsSelectors.selectFeatureFlag).pipe(
      skipUntil(this._store.select(SharedPermissionsSelectors.selectLoaded).pipe(filter(Boolean))),
      map((userFeatureFlags) => !!(userFeatureFlags ?? {})[feature])
    );
  }

  async hasPermissions(permissions: AppPermissions[]): Promise<boolean> {
    return await firstValueFrom(this.hasPermissions$(permissions));
  }

  async hasFeatureAccess(feature: EBetaFeatures): Promise<boolean> {
    return await firstValueFrom(this.hasFeatureAccess$(feature));
  }

}
